<script lang="ts" setup>
defineOptions({
  inheritAttrs: false,
});

const props = defineProps({ label: { type: String, default: '' } });
</script>

<template>
  <div class="relative" :class="{ 'field-has-value': $attrs.value }">
    <a-input-password v-bind="$attrs" class="placeholder-25" />
    <span class="form-field-label">{{ props.label }}</span>
  </div>
</template>

<style scoped>
:deep(.placeholder-25 .ant-input) {
  @apply leading-6;
}
</style>
